import React from 'react';
import PhoneIconHeader from '../Icons/PhoneIconHeader';

const BtnContactUs = (props) => {
  return (
    <a
      id="nav-call"
      href={`${process.env.NEXT_PUBLIC_URL}/hubungi-kami`}
      className="flex text-reliableBlack items-center gap-1 px-3 h-10"
      {...props}
    >
      <PhoneIconHeader size={20} fill={`#4F4C4D`} />
      <p className="text-xs ml-1 font-normal">Hubungi Kami</p>
    </a>
  );
};

export default BtnContactUs;
